import React, { useState ,useEffect} from 'react';
import { Container, Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import * as Yup from "yup";
import {useNavigate} from 'react-router-dom';
import Axios from '../../lib/axios/axiosInstance';

import CustomDateTimePicker from '../InputField/CustomDateTimePicker';
import { Formik } from "formik";
import { Flip, Slide, toast } from 'react-toastify';
import { userLogIn } from "../../services/auth";
import * as AuthVerify from '../../lib/common';

import "./Helpdesk.styles.css";

const CorporateformSchema = Yup.object().shape({
  fName: Yup.string().min(2).max(25).required("First name is required"),
  lName: Yup.string().min(2).max(25).required("Last name is required"),
  // email: Yup.string().email("Email is invalid").required("Email is required"),
  gender: Yup.string().required(),
  dob: Yup.date().required("Date of birth is required"),
});

const Helpdesk = () => {
  const navigate = useNavigate();
  const [isUserLogedIn,setIsUserLogedIn] = useState(false);
  const [acccountDetails, setacccountDetails] = useState(false);
  const [dob, setDob] = useState(null);
  const [initialValue, setInitialValue] = useState({
    fName: "",
    lName: "",
    gender: "",
    dob: "",
  });

  useEffect(() => {
    setIsUserLogedIn(AuthVerify.isUserLogedIn());
	},[])

  const updateFormSubmitHandler = async (values) => {

  }
  return (
    <>
      <section className="main-container col1-layout">
        <Container className="main">
            <div className="col-main">
                <div className="shopping-cart-inner">
                {isUserLogedIn ? <>
                  <div className="col-main">
                    <div className="my-account">
                      <div className="page-title">
                        <h2 style={{ paddingTop: "12px" }}>Your support team from our company.</h2>
                      </div>
                      <div className="dashboard">
                        <div className="page-content checkout-page">
                          <div className="box-border">
                            <Row>
                            <Col xl={4} sm={4} md={4}>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Sales Support
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Contact Number
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Email Address
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                            </Col>

                            <Col xl={4} sm={4} md={4}>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Sales Executive
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Contact Number
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Email Address
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                            </Col>

                            <Col xl={4} sm={4} md={4}>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Sales Manager
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Contact Number
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                              <Row>
                                <Col md={5} className='helpdesk'>
                                  Email Address
                                </Col>
                                <Col md={2}>
                                  :
                                </Col>
                                <Col md={5}>
                                  Manually Input
                                </Col>
                              </Row>
                            </Col>
                            
                            </Row>
                            <br/>
                            <h4 style={{lineHeight:1.4}}>If you need any assistance, you are encourage to click on <a href='/send-us-message'>SEND US MESSAGE</a> otherwise you can reach us at our Hotline below.
                              <br/>Hotline : 6123 4567</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                :
                <>
                  <div className="page-content">
                  <div className="page-content checkout-page">
                  <div className="box-border">
                        <h3 style={{lineHeight:1.4}}>If you need any assistance, you are encourage to click on <a href='/send-us-message'>SEND US MESSAGE</a> otherwise you can reach us at our Hotline below.
                          <br/>Hotline : 6123 4567</h3>
                  </div> 
                  </div>
                  </div>
                </>}
                </div>
            </div>
          </Container>
        </section>
      
    </>
  );
};

export default Helpdesk;
